export default __webpack_public_path__ + "locales/es/SendInviteDialog.json?hash=5ca90308a6e3157c972076474a4172cf";